import { styled } from "@mui/system";

export const StyledImage = styled("img")(
  ({ theme }) => `
  width: 100%;
`
);
